import { CheckCircle2, XCircle } from "lucide-react";

export function VerdictBanner({ verdict, knots }) {
  const kid = verdict?.sail_kid;
  const adult = verdict?.sail_adult;
  const chosen = verdict?.set ? verdict.verdict : "";

  if (chosen !== "worth" && chosen !== "sleep") {
    return (
      <div className="bg-slate-100 border-b border-slate-200" data-testid="verdict-banner-empty">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 text-center text-sm text-slate-500 font-medium">
          Seba non ha ancora dato il verdetto di oggi... 🤙
        </div>
      </div>
    );
  }

  const worth = chosen === "worth";

  return (
    <div className={worth ? "bg-emerald-500" : "bg-red-600"} data-testid="verdict-banner">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <div className="flex items-center gap-3">
          {worth ? (
            <CheckCircle2 className="h-8 w-8 text-white shrink-0" />
          ) : (
            <XCircle className="h-8 w-8 text-white shrink-0" />
          )}
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/70">
              Il verdetto di Seba{knots != null ? ` · ${Math.round(knots)} nodi` : ""}
            </div>
            <div className="font-head text-2xl sm:text-3xl font-extrabold text-white leading-tight" data-testid="verdict-text">
              {worth ? "VALE LA PENA" : "È NA MERDA, tornate pure a dormire"}
            </div>
          </div>
        </div>

        {worth && (kid || adult) && (
          <div className="sm:ml-auto flex items-center gap-3 bg-white/15 rounded-2xl px-4 py-2 backdrop-blur-sm">
            <div className="h-10 w-10 rounded-xl bg-white flex items-center justify-center shrink-0 shadow-sm">
              <img src="/sail.png" alt="vela" className="h-8 w-8 object-contain" data-testid="sail-icon" />
            </div>
            <div className="flex gap-4">
              <div data-testid="sail-kid">
                <div className="text-[10px] uppercase tracking-widest font-bold text-white/70">Bambino</div>
                <div className="font-head text-xl font-extrabold text-white">{kid || "—"}</div>
              </div>
              <div className="w-px bg-white/30" />
              <div data-testid="sail-adult">
                <div className="text-[10px] uppercase tracking-widest font-bold text-white/70">Adulti</div>
                <div className="font-head text-xl font-extrabold text-white">{adult || "—"}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
